export default "__VITE_ASSET__BqILS3xz__"